/**
 * Tracks which bulk imports currently have a wizard modal open on them.
 *
 * When the wizard is open it shows the outcome on its own summary step, so the
 * app-level toast would be a duplicate. When it has been closed there is
 * nothing left to show the user, which is what the toast is for.
 *
 * Deliberately module-level rather than React state: the only reader is an
 * event handler deciding whether to fire a toast, so nothing needs to
 * re-render when it changes, and the three wizards live in different parts of
 * the tree.
 */
const openImportIds = new Set<string>();

export function claimOpenImport(importId: string): void {
  openImportIds.add(importId);
}

export function releaseOpenImport(importId: string): void {
  openImportIds.delete(importId);
}

export function isImportOpen(importId?: string | null): boolean {
  return !!importId && openImportIds.has(importId);
}

/** Test helper — production code has no reason to clear the whole registry. */
export function resetOpenImports(): void {
  openImportIds.clear();
}
